'use client'
import React from 'react'

const privacySections = [
   {
      title: 'Who we are',
      content: [
         {
            type: 'description',
            text: (
               <>
                  Our website address is:{' '}
                  <a
                     href="https://benzatine.com"
                     target="_blank"
                     rel="noopener noreferrer"
                     className="link-span"
                  >
                     https://benzatine.com
                  </a>
               </>
            ),
         },
      ],
   },
   {
      title: 'What personal data we collect and why we collect it',
      content: [
         {
            type: 'subtitle',
            text: 'Comments',
         },
         {
            type: 'description',
            text: 'When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor\'s IP address and browser user agent string to help spam detection.',
         },
         {
            type: 'description',
            text: 'An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. After approval of your comment, your profile picture is visible to the public in the context of your comment.',
         },
         {
            type: 'subtitle',
            text: 'Media',
         },
         {
            type: 'description',
            text: 'If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.',
         },
      ],
   },
   {
      title: 'Contact forms',
      content: [
         {
            type: 'subtitle',
            text: 'Cookies',
         },
         {
            type: 'description',
            text: 'If you leave a comment on our site you may opt-in to saving your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.',
         },
         {
            type: 'description',
            text: 'If you visit our login page, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.',
         },
         {
            type: 'description',
            text: 'When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select "Remember Me", your login will persist for two weeks. If you log out of your account, the login cookies will be removed.',
         },
         {
            type: 'description',
            text: 'If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.',
         },
         {
            type: 'subtitle',
            text: 'Embedded content from other websites',
         },
         {
            type: 'description',
            text: 'Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.',
         },
         {
            type: 'description',
            text: 'These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.',
         },
      ],
   },
   {
      title: 'With whom we share your data with',
      content: [
         {
            type: 'subtitle',
            text: 'How long we retain your data',
         },
         {
            type: 'description',
            text: 'If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.',
         },
         {
            type: 'description',
            text: 'For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.',
         },
      ],
   },
   {
      title: 'Additional information',
      content: [
         {
            type: 'subtitle',
            text: 'How we protect your data',
         },
         {
            type: 'description',
            text: 'We follow appropriate data collection, storage, and processing policies and security protocols to protect against unauthorized access, alteration, disclosure, or destruction of your personal information, username, password, transaction information, and data stored on our site. The Site and its users share confidential and private data through an SSL secured communication channel and digital signatures are encrypted and protected. To create a secure environment as possible for users, our site is also in compliance with PCI vulnerability requirements.',
         },
         {
            type: 'subtitle',
            text: 'Changes to this privacy policy',
         },
         {
            type: 'description',
            text: 'The discretion of Benzatine Infotech is to change this privacy policy at any time. When we do, at the bottom of this page, we will update the new date. Users are encouraged to review this page regularly for any updates to remain aware of how we help protect the personal information we receive. You understand and accept that you must regularly review this privacy policy and become aware of changes.',
         },
         {
            type: 'subtitle',
            text: 'Your acceptance of these terms',
         },
         {
            type: 'description',
            text: 'You signify your approval of this policy by using this site. Please do not utilize our website if you disagree with our policy. Your continued use of the site after the updates to this policy has been posted will be considered your approval of those changes.',
         },
      ],
   },
];

function PrivacyPolicySection() {
   return (
      <section className="section_secondary_bg first-section">
         <div className="container container-xxl">
            <h1 className="text-center tech_title section_heading_title mb-2">
               Our Privacy Policy
            </h1>
            <p className="section_desc mb-0 privacy-section-desc">
               We love our customers and their privacy is our top most priority as it
               is most valuable
            </p>
            <div className="container">
               <div className="privacy-parent">
                  {privacySections.map((section, index) => (
                     <div key={index} className={index > 0 ? 'common-privacy-margin' : ''}>
                        <h3 className="tech_body footer_card_first">
                           {section.title}
                        </h3>
                        {section.content.map((item, itemIndex) => {
                           if (item.type === 'subtitle') {
                              return (
                                 <h4 key={itemIndex} className="intro_sub_titel">
                                    {item.text}
                                 </h4>
                              );
                           } else if (item.type === 'description') {
                              return (
                                 <div key={itemIndex} className="intro_description">
                                    {item.text}
                                 </div>
                              );
                           }
                           return null;
                        })}
                     </div>
                  ))}
               </div>
            </div>
         </div>
      </section>)
}

export default PrivacyPolicySection
